<template>
  <transition name="fade">
    <div v-show="isOpen" class="dealer-modal">
      <span @click="closeModal(); trackModalEvent()" class="icon icon-stihl-cross closer"></span>
      <h2 class="dealer-name">{{ dealerName }}</h2>

      <StarRating
        :reviewRating="dealerRating"
        :reviewCount="reviewCount"
      />

      <div v-if="!!dealer && !!dealer.address" class="dealer-address">
        <div v-if="dealer.address.address1" class="address-1">{{ dealer.address.address1 }}</div>
        <div v-show="dealer.address.address2" class="address-2">{{ dealer.address.address2 }}</div>
        <div class="address-state">{{ dealer.address.city }} {{ dealer.address.state }} {{ dealer.address.postalCode }}</div>
      </div>

      <div class="dealer-hours" v-show="showStoreHours">
        <span class="today">{{ "dealers.details.storeHours.today" | t }}</span>
        <span v-if="!!dealerStoreHours"
          class="today-time"
        >{{ dealer.storeHours.today.open | toTime }} - {{ dealer.storeHours.today.close | toTime }}</span>
      </div>

      <section class="ctas">
        <DealerButtons />

        <div class="cta-links">
          <a v-show="directionsLink" :href="directionsLink" @click="clickGetDirections">
            <span class="icon icon-stihl-angle-right"></span>
            {{ "dealers.details.getDirections" | t }}
          </a>

          <a v-show="dealerPhone" :href="`tel:${dealerPhone}`" @click="clickCall">
            <span class="icon icon-stihl-angle-right"></span>
            {{ dealerPhone }}
          </a>
        </div>
      </section>

      <DealerDetails :details="dealerTags" />
      <StoreHours :storeHours="dealerStoreHours" />
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import StoreHours from "@/components/StoreHours";
import DealerDetails from "@/components/DealerDetails";
import DealerButtons from "@/components/DealerButtons";
import StarRating from "@/components/StarRating";

export default {
  name: "DealerModal",
  props: {
    isOpen: Boolean
  },
  computed: {
    ...mapGetters("DealerHeader", [
      "dealer",
      "dealerName",
      "dealerRating",
      "reviewCount",
      "showStoreHours",
      "dealerStoreHours",
      "directionsLink",
      "dealerPhone",
      "dealerTags"
    ])
  },
  methods: {
     ...mapActions("DealerHeader", ["closeModal"]),
    trackModalEvent() {
      this.$dataLayer.push({ event: "pcedh.header-closed" })
    },
    clickGetDirections() {
      this.$dataLayer.push({ event: "pcedh.get-directions-clicked" })
    }, 
    clickCall() {
      this.$dataLayer.push({ event: "pcedh.call-clicked" })
    }
  },
  components: {
    StoreHours,
    DealerDetails,
    DealerButtons,
    StarRating
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.dealer-modal {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2), 0 12px 12px 0 rgba(0, 0, 0, 0.19);
  z-index: 10001;
  color: black;
  background: $white;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  position: absolute;
  right: 0;
  left: 0;
  padding: 0 $gutter;

  ::v-deep .star-rating {
    padding: 10px 0 10px 0;
    height: 24px;
    .star-icon {
      font-size: 1.1em;
    }
    .review-count {
      font-size: 0.9em;
      line-height: 28px;
    }
    .star-container {
      // IE Hack for svg sizing
      @media all and (-ms-high-contrast: none) {
        height: 2em;
      }
    }
  }

  @media screen and (max-width: $breakpoint-md) {
    top: 100%;
    padding-top: $gutter;
  }

  .icon {
    font-family: $font-icons;
  }
  .icon-stihl-cross {
    text-align: right;
    color: $icon-secondary;
    margin-top: $gutter;
    cursor: pointer;
  }
  h4 {
    font-size: 1.428em;
  }
  .dealer-name {
    font-family: $font-title;
    font-size: 2em;
    margin: 0 0 $gutter-sm;
    max-width: 90%;
    line-height: 1em;
    @media screen and (min-width: $breakpoint-md) {
      font-size: 2.285em;
    }
  }
  .dealer-address {
    font-family: $font-title;
    font-size: 1.285em;
    color: #444;
    line-height: 1.714;
    margin-bottom: $gutter;
  }
  .dealer-hours {
    text-align: left;
    flex-direction: row;
    margin-bottom: $gutter-lg;
    .today {
      font-family: $font-title;
      color: $primary;
      font-weight: bold;
      font-size: 1.285em;
    }
    .today-time {
      font-family: $font-text;
      color: $text-muted;
      font-size: 1.285em;
      text-transform: lowercase;
      line-height: 1.714;
      padding-left: $gutter-sm;
    }
  }
  .ctas {
    display: flex;
    flex-direction: row;
    margin-bottom: $gutter-lg;
    .cta-links {
      flex: 1;
      order: 1;
    }
    .cta-links a {
      color: $primary;
      display: table;
      margin-bottom: $gutter;
      cursor: pointer;
      font-family: $font-title;
      text-decoration: none;
    }

    @media only screen and (max-width: $breakpoint-md) {
      flex-direction: column;
      .cta-links {
        order: 2;
      }
      .cta-buttons {
        order: 1;
      }
    }
  }

  @media only screen and (max-width: $breakpoint-md) {
    .closer {
      display: none;
    }
    .dealer-modal {
      width: fit-content;
      margin-top: 3.714em;
    }
    .ctas {
      flex-direction: column;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
